/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZgloszenieIdentyfikator } from '../../models/zgloszenie-identyfikator';

export interface ApiWebInstytucjeNipHistoriaGet$Xml$Params {
  nip: string;
  status?: string;
}

export function apiWebInstytucjeNipHistoriaGet$Xml(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipHistoriaGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZgloszenieIdentyfikator>>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipHistoriaGet$Xml.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ZgloszenieIdentyfikator>>;
    })
  );
}

apiWebInstytucjeNipHistoriaGet$Xml.PATH = '/api/web/instytucje/{nip}/historia';
